import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  environmentData: {},
};

const environmentSlice = createSlice({
  name: 'environment',
  initialState,
  reducers: {
    setEnvironmentData: (state, action) => {
      state.environmentData = action.payload;
    },
    clearEnvironmentData: (state) => {
      state.environmentData = {};
    },
    restoreEnvironmentHistory: (state, action) => {
      state.environmentData = action.payload || {};
    },
  },
});

export const { setEnvironmentData, clearEnvironmentData, restoreEnvironmentHistory } =
  environmentSlice.actions;
export const selectEnvironmentData = (state) =>
  state.environment.environmentData;

export default environmentSlice.reducer;
